export default "__VITE_ASSET__8143d25b__"